import React, { useState } from 'react';
import { SlidingScale } from '../../survey-tools/likert-scales';
import { Button, Typography } from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed


function ValenceScale({ instanceId,nextTask }) {
    const [sliderValue, setSliderValue] = useState(50);
    const [sliderMoved, setSliderMoved] = useState(false); // State to track if the slider has been moved
    const [showDialog, setShowDialog] = useState(false);

    const handleChange = (newValue) => {
        if (!sliderMoved) setSliderMoved(true); // Update sliderMoved to true on first interaction
        setSliderValue(newValue);
    };

    const handleNext = () => {
        if (!sliderMoved) { // Check if the slider has never been moved
            setShowDialog(true); // Show the dialog if the slider hasn't been moved
        } else {
            nextTask({ data: { [instanceId]: sliderValue } });
        }};
    
    const question = (
        

        <div>
    
            <Typography gutterBottom>
                On a scale from 0-100, indicate the <strong>Valence</strong> of your current state, where 0 is negative and 100 is positive.
            </Typography>
            <Typography gutterBottom style={{ marginTop: '1em' }}>
                <strong>Negative</strong> refers to disagreeable or unpleasant states.
            </Typography>
            <Typography gutterBottom>
                <strong>Positive</strong> refers to agreeable or pleasant states.

            </Typography>
            <Typography gutterBottom style={{ marginTop: '1em' }}>
                For example, states that are <strong>negative</strong> are <strong>distress, terror, guilt,</strong> and <strong>despair</strong>, while states that are <strong>positive</strong> are <strong>affection, pleasure, excitement, and delight.</strong>
            </Typography>
        </div>
    );

    return (
        <PageContainer>

        <div>
            <SlidingScale 
                question={question} 
                leftLabel="Negative" 
                rightLabel="Positive" 
                handleUpdate={handleChange}
            />
            <Button variant="contained" onClick={handleNext}>Next</Button>
            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    nextTask({ data: { [instanceId]: sliderValue } });
                }}
            />
                    </div>

        </PageContainer>
    );
};


const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(ValenceScale);

